import React, { Suspense } from 'react'

export const withSuspense = <P extends object>({
  component: Component,
  fallback = <></>,
}: {
  component: React.LazyExoticComponent<React.ComponentType<P>>
  fallback?: NonNullable<React.ReactNode> | null
}) => {
  return (props: any) => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  )
}
